import debounce from "lodash/debounce"

export default function cloneElWidth(opts = {}) {
  const cloneFrom = opts.cloneFrom
  const cloneTo = opts.cloneTo

  cloneWidth(cloneFrom, cloneTo)

  window.addEventListener("resize", () =>
    debounce(cloneWidth, 300, {
      leading: false,
      trailing: true,
    })(cloneFrom, cloneTo)
  )
}

function cloneWidth(cloneFrom, cloneTo) {
  const sourceEl = document.querySelector(cloneFrom)
  const targetEl = document.querySelector(cloneTo)
  const elStyle = sourceEl && window.getComputedStyle(sourceEl, null)

  if (targetEl && elStyle) {
    targetEl.style.width = elStyle.width
  }
}
